import { render } from "./changeService.vue?vue&type=template&id=cba22f64"
import script from "./changeService.vue?vue&type=script&lang=js"
export * from "./changeService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__